/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import PieChart, { parsePieChartConfig } from "./PieChart";

const VisitsPieChart = ({data, scope}) => {
  // check data exists
  const chartConfig = parsePieChartConfig(data, scope);

  return chartConfig ? (
    <PieChart
      title="Guest Visits"
      subtitle={chartConfig.name}
      data={chartConfig.data}
    />
  ) : null;
};

export default VisitsPieChart;
